import { put, all, takeEvery, fork, call } from "redux-saga/effects";

import { actions } from "./model";
import { registerError } from "redux/modules/errors/actions";

import { apiCall } from "App/Data/sagas";

import Auth from "../../lib/Auth/Auth";

const init = function*({ payload: { eventUUID, accountId, email } }) {
  try {
    const { payload } = yield call(apiCall, {
      method: "post",
      url: `/portal/sso-link/event/${eventUUID}/account/${accountId}`,
      data: {
        email: email ? email.toLowerCase().trim() : null
      }
    });

    const tokens = {
      accessToken: payload.access_token,
      idToken: payload.id_token,
      refreshToken: payload.refresh_token
    };

    window.webAuth = new Auth(
      // eslint-disable-next-line no-underscore-dangle
      window.__LENND_API_BASE_URL__,
      // eslint-disable-next-line no-underscore-dangle
      window.__LENND_APP_URL__
    );

    Auth.setTokens(tokens);

    window.location = `/portals/tech-stack/${eventUUID}`;
  } catch (e) {
    const message = e?.body?.message || "An error occurred";
    yield all([
      put(actions.setErrorMessage(message)),
      put(
        registerError([
          {
            system: e,
            user: message
          }
        ])
      )
    ]);
  } finally {
    yield put(actions.setLoading(false));
  }
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const rootSaga = function*() {
  yield all([fork(watchInit)]);
};

export default rootSaga;
